import request from '@/utils/request'

// 保存专家抽取
export const saveExpertSelection = (data) => {
    return request.post('/api/api/expertselection/save',data)
}
//获取专家抽取配置
export const getExpertSelection = (data) => {
    return request.get('/api/api/expertselection/getExpertSelection',data)
}
//获取抽取项目列表
export const getSectionList = (data) => {
    return request.get('/api/api/expertselection/getSectionList',data)
}
//列表
export const listPage = (data) => {
    return request.post('/api/api/expertselection/listPage',data)
}

//获取专家数量
export const getExpertCount = (data) => {
    return request.get('/api/api/expertselection/getExpertCount',data)
}
//获取专家抽取审核列表
export const getExpertSelectionAuditList = (data) => {
    return request.get('/api/api/expertselection/getExpertSelectionList',data)
}
//审核通过
export const passExpertSelection = (data) => {
    return request.get('/api/api/expertselection/pass',data)
}
// 抽取
export const expertSelection = (data) => {
    return request.get('/api/api/expertselection/expertSelection',data)
}

// 获取专家抽取结果
export const getSelectionResult=(data)=>{
    return request.get('/api/api/expertselection/getSelectionResult',data)
}
//获取专家抽取配置详情
export const getExpertSelectionDetails =(data)=>{
     return request.get('/api/api/expertselection/getExpertSelection',data)
}
//专家请假
export const setLeave = (data) => {
    return request.post('/api/api/expertselection/setLeave',data)
}
//设置专家是否参加
export const setParticipate = (data) => {
    return request.post('/api/api/expertselection/setParticipate',data)
}

//获取甲方代表列表
export const getRepresentList = (data) => {
    return request.get('/api/api/expertselection/getRepresentList', data)
}

//修改甲方代表信息
export const updateRepresent = (data) => {
    return request.post('/api/api/expertselection/updateRepresent', data)
}
//发送短信
export const sendSms = (data) => {
   return request.get('/api/api/expertselection/sendSms',data)
}
//获取评标专家抽取详情
export const getExpertSelectionDetail = (expertSelectionMainId) => {
   return request.get('/api/api/expertselection/getExpertSelectionDetail?expertSelectionMainId='+expertSelectionMainId)
}
